module.exports = __webpack_public_path__ + "media/assets/img/flags/el-GR-d19290ba3158e138bb241ae669a3bc37.png";